export const allCountries = [
  { code: "+93", name: "Afeganistão", flag: "🇦🇫", iso: "af" },
  { code: "+355", name: "Albânia", flag: "🇦🇱", iso: "al" },
  { code: "+213", name: "Argélia", flag: "🇩🇿", iso: "dz" },
  { code: "+376", name: "Andorra", flag: "🇦🇩", iso: "ad" },
  { code: "+244", name: "Angola", flag: "🇦🇴", iso: "ao" },
  { code: "+54", name: "Argentina", flag: "🇦🇷", iso: "ar" },
  { code: "+374", name: "Armênia", flag: "🇦🇲", iso: "am" },
  { code: "+61", name: "Austrália", flag: "🇦🇺", iso: "au" },
  { code: "+43", name: "Áustria", flag: "🇦🇹", iso: "at" },
  { code: "+994", name: "Azerbaijão", flag: "🇦🇿", iso: "az" },
  { code: "+973", name: "Bahrein", flag: "🇧🇭", iso: "bh" },
  { code: "+880", name: "Bangladesh", flag: "🇧🇩", iso: "bd" },
  { code: "+375", name: "Bielorrússia", flag: "🇧🇾", iso: "by" },
  { code: "+32", name: "Bélgica", flag: "🇧🇪", iso: "be" },
  { code: "+501", name: "Belize", flag: "🇧🇿", iso: "bz" },
  { code: "+229", name: "Benin", flag: "🇧🇯", iso: "bj" },
  { code: "+975", name: "Butão", flag: "🇧🇹", iso: "bt" },
  { code: "+591", name: "Bolívia", flag: "🇧🇴", iso: "bo" },
  { code: "+387", name: "Bósnia e Herzegovina", flag: "🇧🇦", iso: "ba" },
  { code: "+267", name: "Botsuana", flag: "🇧🇼", iso: "bw" },
  { code: "+55", name: "Brasil", flag: "🇧🇷", iso: "br" },
  { code: "+673", name: "Brunei", flag: "🇧🇳", iso: "bn" },
  { code: "+359", name: "Bulgária", flag: "🇧🇬", iso: "bg" },
  { code: "+226", name: "Burkina Faso", flag: "🇧🇫", iso: "bf" },
  { code: "+257", name: "Burundi", flag: "🇧🇮", iso: "bi" },
  { code: "+855", name: "Camboja", flag: "🇰🇭", iso: "kh" },
  { code: "+237", name: "Camarões", flag: "🇨🇲", iso: "cm" },
  { code: "+1", name: "Canadá", flag: "🇨🇦", iso: "ca" },
  { code: "+238", name: "Cabo Verde", flag: "🇨🇻", iso: "cv" },
  { code: "+236", name: "República Centro-Africana", flag: "🇨🇫", iso: "cf" },
  { code: "+235", name: "Chade", flag: "🇹🇩", iso: "td" },
  { code: "+56", name: "Chile", flag: "🇨🇱", iso: "cl" },
  { code: "+86", name: "China", flag: "🇨🇳", iso: "cn" },
  { code: "+57", name: "Colômbia", flag: "🇨🇴", iso: "co" },
  { code: "+269", name: "Comores", flag: "🇰🇲", iso: "km" },
  { code: "+242", name: "Congo", flag: "🇨🇬", iso: "cg" },
  { code: "+243", name: "Congo (Rep. Dem.)", flag: "🇨🇩", iso: "cd" },
  { code: "+506", name: "Costa Rica", flag: "🇨🇷", iso: "cr" },
  { code: "+225", name: "Costa do Marfim", flag: "🇨🇮", iso: "ci" },
  { code: "+385", name: "Croácia", flag: "🇭🇷", iso: "hr" },
  { code: "+53", name: "Cuba", flag: "🇨🇺", iso: "cu" },
  { code: "+357", name: "Chipre", flag: "🇨🇾", iso: "cy" },
  { code: "+420", name: "República Tcheca", flag: "🇨🇿", iso: "cz" },
  { code: "+45", name: "Dinamarca", flag: "🇩🇰", iso: "dk" },
  { code: "+253", name: "Djibuti", flag: "🇩🇯", iso: "dj" },
  { code: "+1-767", name: "Dominica", flag: "🇩🇲", iso: "dm" },
  { code: "+1-809", name: "República Dominicana", flag: "🇩🇴", iso: "do" },
  { code: "+593", name: "Equador", flag: "🇪🇨", iso: "ec" },
  { code: "+20", name: "Egito", flag: "🇪🇬", iso: "eg" },
  { code: "+503", name: "El Salvador", flag: "🇸🇻", iso: "sv" },
  { code: "+240", name: "Guiné Equatorial", flag: "🇬🇶", iso: "gq" },
  { code: "+291", name: "Eritreia", flag: "🇪🇷", iso: "er" },
  { code: "+372", name: "Estônia", flag: "🇪🇪", iso: "ee" },
  { code: "+251", name: "Etiópia", flag: "🇪🇹", iso: "et" },
  { code: "+679", name: "Fiji", flag: "🇫🇯", iso: "fj" },
  { code: "+358", name: "Finlândia", flag: "🇫🇮", iso: "fi" },
  { code: "+33", name: "França", flag: "🇫🇷", iso: "fr" },
  { code: "+241", name: "Gabão", flag: "🇬🇦", iso: "ga" },
  { code: "+220", name: "Gâmbia", flag: "🇬🇲", iso: "gm" },
  { code: "+995", name: "Geórgia", flag: "🇬🇪", iso: "ge" },
  { code: "+49", name: "Alemanha", flag: "🇩🇪", iso: "de" },
  { code: "+233", name: "Gana", flag: "🇬🇭", iso: "gh" },
  { code: "+30", name: "Grécia", flag: "🇬🇷", iso: "gr" },
  { code: "+502", name: "Guatemala", flag: "🇬🇹", iso: "gt" },
  { code: "+224", name: "Guiné", flag: "🇬🇳", iso: "gn" },
  { code: "+245", name: "Guiné-Bissau", flag: "🇬🇼", iso: "gw" },
  { code: "+592", name: "Guiana", flag: "🇬🇾", iso: "gy" },
  { code: "+509", name: "Haiti", flag: "🇭🇹", iso: "ht" },
  { code: "+504", name: "Honduras", flag: "🇭🇳", iso: "hn" },
  { code: "+36", name: "Hungria", flag: "🇭🇺", iso: "hu" },
  { code: "+354", name: "Islândia", flag: "🇮🇸", iso: "is" },
  { code: "+91", name: "Índia", flag: "🇮🇳", iso: "in" },
  { code: "+62", name: "Indonésia", flag: "🇮🇩", iso: "id" },
  { code: "+98", name: "Irã", flag: "🇮🇷", iso: "ir" },
  { code: "+964", name: "Iraque", flag: "🇮🇶", iso: "iq" },
  { code: "+353", name: "Irlanda", flag: "🇮🇪", iso: "ie" },
  { code: "+972", name: "Israel", flag: "🇮🇱", iso: "il" },
  { code: "+39", name: "Itália", flag: "🇮🇹", iso: "it" },
  { code: "+1", name: "Jamaica", flag: "🇯🇲", iso: "jm" },
  { code: "+81", name: "Japão", flag: "🇯🇵", iso: "jp" },
  { code: "+962", name: "Jordânia", flag: "🇯🇴", iso: "jo" },
  { code: "+7", name: "Cazaquistão", flag: "🇰🇿", iso: "kz" },
  { code: "+254", name: "Quênia", flag: "🇰🇪", iso: "ke" },
  { code: "+686", name: "Kiribati", flag: "🇰🇮", iso: "ki" },
  { code: "+965", name: "Kuwait", flag: "🇰🇼", iso: "kw" },
  { code: "+996", name: "Quirguistão", flag: "🇰🇬", iso: "kg" },
  { code: "+856", name: "Laos", flag: "🇱🇦", iso: "la" },
  { code: "+371", name: "Letônia", flag: "🇱🇻", iso: "lv" },
  { code: "+961", name: "Líbano", flag: "🇱🇧", iso: "lb" },
  { code: "+266", name: "Lesoto", flag: "🇱🇸", iso: "ls" },
  { code: "+231", name: "Libéria", flag: "🇱🇷", iso: "lr" },
  { code: "+218", name: "Líbia", flag: "🇱🇾", iso: "ly" },
  { code: "+423", name: "Liechtenstein", flag: "🇱🇮", iso: "li" },
  { code: "+370", name: "Lituânia", flag: "🇱🇹", iso: "lt" },
  { code: "+352", name: "Luxemburgo", flag: "🇱🇺", iso: "lu" },
  { code: "+853", name: "Macau", flag: "🇲🇴", iso: "mo" },
  { code: "+389", name: "Macedônia do Norte", flag: "🇲🇰", iso: "mk" },
  { code: "+261", name: "Madagáscar", flag: "🇲🇬", iso: "mg" },
  { code: "+265", name: "Malawi", flag: "🇲🇼", iso: "mw" },
  { code: "+60", name: "Malásia", flag: "🇲🇾", iso: "my" },
  { code: "+960", name: "Maldivas", flag: "🇲🇻", iso: "mv" },
  { code: "+223", name: "Mali", flag: "🇲🇱", iso: "ml" },
  { code: "+356", name: "Malta", flag: "🇲🇹", iso: "mt" },
  { code: "+692", name: "Ilhas Marshall", flag: "🇲🇭", iso: "mh" },
  { code: "+222", name: "Mauritânia", flag: "🇲🇷", iso: "mr" },
  { code: "+230", name: "Maurício", flag: "🇲🇺", iso: "mu" },
  { code: "+52", name: "México", flag: "🇲🇽", iso: "mx" },
  { code: "+691", name: "Micronésia", flag: "🇫🇲", iso: "fm" },
  { code: "+373", name: "Moldávia", flag: "🇲🇩", iso: "md" },
  { code: "+377", name: "Mônaco", flag: "🇲🇨", iso: "mc" },
  { code: "+976", name: "Mongólia", flag: "🇲🇳", iso: "mn" },
  { code: "+382", name: "Montenegro", flag: "🇲🇪", iso: "me" },
  { code: "+212", name: "Marrocos", flag: "🇲🇦", iso: "ma" },
  { code: "+258", name: "Moçambique", flag: "🇲🇿", iso: "mz" },
  { code: "+95", name: "Mianmar", flag: "🇲🇲", iso: "mm" },
  { code: "+264", name: "Namíbia", flag: "🇳🇦", iso: "na" },
  { code: "+674", name: "Nauru", flag: "🇳🇷", iso: "nr" },
  { code: "+977", name: "Nepal", flag: "🇳🇵", iso: "np" },
  { code: "+31", name: "Países Baixos", flag: "🇳🇱", iso: "nl" },
  { code: "+64", name: "Nova Zelândia", flag: "🇳🇿", iso: "nz" },
  { code: "+505", name: "Nicarágua", flag: "🇳🇮", iso: "ni" },
  { code: "+227", name: "Níger", flag: "🇳🇪", iso: "ne" },
  { code: "+234", name: "Nigéria", flag: "🇳🇬", iso: "ng" },
  { code: "+47", name: "Noruega", flag: "🇳🇴", iso: "no" },
  { code: "+968", name: "Omã", flag: "🇴🇲", iso: "om" },
  { code: "+92", name: "Paquistão", flag: "🇵🇰", iso: "pk" },
  { code: "+680", name: "Palau", flag: "🇵🇼", iso: "pw" },
  { code: "+970", name: "Palestina", flag: "🇵🇸", iso: "ps" },
  { code: "+507", name: "Panamá", flag: "🇵🇦", iso: "pa" },
  { code: "+675", name: "Papua-Nova Guiné", flag: "🇵🇬", iso: "pg" },
  { code: "+595", name: "Paraguai", flag: "🇵🇾", iso: "py" },
  { code: "+51", name: "Peru", flag: "🇵🇪", iso: "pe" },
  { code: "+63", name: "Filipinas", flag: "🇵🇭", iso: "ph" },
  { code: "+48", name: "Polônia", flag: "🇵🇱", iso: "pl" },
   { code: "+351", name: "Portugal", flag: "🇵🇹", iso: "pt" },
  { code: "+974", name: "Catar", flag: "🇶🇦", iso: "qa" },
  { code: "+40", name: "Romênia", flag: "🇷🇴", iso: "ro" },
  { code: "+7", name: "Rússia", flag: "🇷🇺", iso: "ru" },
  { code: "+250", name: "Ruanda", flag: "🇷🇼", iso: "rw" },
  { code: "+1-869", name: "São Cristóvão e Nevis", flag: "🇰🇳", iso: "kn" },
  { code: "+1-758", name: "Santa Lúcia", flag: "🇱🇨", iso: "lc" },
  { code: "+1-784", name: "São Vicente e Granadinas", flag: "🇻🇨", iso: "vc" },
  { code: "+685", name: "Samoa", flag: "🇼🇸", iso: "ws" },
  { code: "+378", name: "San Marino", flag: "🇸🇲", iso: "sm" },
  { code: "+239", name: "São Tomé e Príncipe", flag: "🇸🇹", iso: "st" },
  { code: "+966", name: "Arábia Saudita", flag: "🇸🇦", iso: "sa" },
  { code: "+221", name: "Senegal", flag: "🇸🇳", iso: "sn" },
  { code: "+381", name: "Sérvia", flag: "🇷🇸", iso: "rs" },
  { code: "+248", name: "Seicheles", flag: "🇸🇨", iso: "sc" },
  { code: "+232", name: "Serra Leoa", flag: "🇸🇱", iso: "sl" },
  { code: "+65", name: "Singapura", flag: "🇸🇬", iso: "sg" },
  { code: "+421", name: "Eslováquia", flag: "🇸🇰", iso: "sk" },
  { code: "+386", name: "Eslovênia", flag: "🇸🇮", iso: "si" },
  { code: "+677", name: "Ilhas Salomão", flag: "🇸🇧", iso: "sb" },
  { code: "+252", name: "Somália", flag: "🇸🇴", iso: "so" },
  { code: "+27", name: "África do Sul", flag: "🇿🇦", iso: "za" },
  { code: "+82", name: "Coreia do Sul", flag: "🇰🇷", iso: "kr" },
  { code: "+211", name: "Sudão do Sul", flag: "🇸🇸", iso: "ss" },
  { code: "+34", name: "Espanha", flag: "🇪🇸", iso: "es" },
  { code: "+94", name: "Sri Lanka", flag: "🇱🇰", iso: "lk" },
  { code: "+249", name: "Sudão", flag: "🇸🇩", iso: "sd" },
  { code: "+597", name: "Suriname", flag: "🇸🇷", iso: "sr" },
  { code: "+46", name: "Suécia", flag: "🇸🇪", iso: "se" },
  { code: "+41", name: "Suíça", flag: "🇨🇭", iso: "ch" },
  { code: "+963", name: "Síria", flag: "🇸🇾", iso: "sy" },
  { code: "+886", name: "Taiwan", flag: "🇹🇼", iso: "tw" },
  { code: "+992", name: "Tajiquistão", flag: "🇹🇯", iso: "tj" },
  { code: "+255", name: "Tanzânia", flag: "🇹🇿", iso: "tz" },
  { code: "+66", name: "Tailândia", flag: "🇹🇭", iso: "th" },
  { code: "+228", name: "Togo", flag: "🇹🇬", iso: "tg" },
  { code: "+676", name: "Tonga", flag: "🇹🇴", iso: "to" },
  { code: "+1-868", name: "Trinidad e Tobago", flag: "🇹🇹", iso: "tt" },
  { code: "+216", name: "Tunísia", flag: "🇹🇳", iso: "tn" },
  { code: "+90", name: "Turquia", flag: "🇹🇷", iso: "tr" },
  { code: "+993", name: "Turcomenistão", flag: "🇹🇲", iso: "tm" },
  { code: "+688", name: "Tuvalu", flag: "🇹🇻", iso: "tv" },
  { code: "+256", name: "Uganda", flag: "🇺🇬", iso: "ug" },
  { code: "+380", name: "Ucrânia", flag: "🇺🇦", iso: "ua" },
  { code: "+971", name: "Emirados Árabes Unidos", flag: "🇦🇪", iso: "ae" },
  { code: "+44", name: "Reino Unido", flag: "🇬🇧", iso: "gb" },
  { code: "+1", name: "Estados Unidos", flag: "🇺🇸", iso: "us" },
  { code: "+598", name: "Uruguai", flag: "🇺🇾", iso: "uy" },
  { code: "+998", name: "Uzbequistão", flag: "🇺🇿", iso: "uz" },
  { code: "+678", name: "Vanuatu", flag: "🇻🇺", iso: "vu" },
  { code: "+58", name: "Venezuela", flag: "🇻🇪", iso: "ve" },
  { code: "+84", name: "Vietnã", flag: "🇻🇳", iso: "vn" },
  { code: "+967", name: "Iémen", flag: "🇾🇪", iso: "ye" },
  { code: "+260", name: "Zâmbia", flag: "🇿🇲", iso: "zm" },
  { code: "+263", name: "Zimbábue", flag: "🇿🇼", iso: "zw" }
];
